import React from "react";

const QueueCompanyFilter = ({
  selected,
  handleClick,
  companies,
  handleSort,
}) => (
  <div className="mb2">
    <div className="mt2">
      <b>Filter Urls: </b>
      <select
        name="important"
        onChange={e => handleClick(null, e.currentTarget.value)}
      >
        <option value="false">All URLs</option>
        <option value="true">URLs that have had tests</option>
        <option value="landing">URLs that are SEM landing pages</option>
      </select>
    </div>
    <div className="mt2">
      <b>Filter by country: </b>
      <select
        name="country"
        onChange={e => handleClick(null, null, e.currentTarget.value)}
      >
        <option value="all">All</option>
        <option value="us">US</option>
        <option value="uk">UK</option>
        <option value="au">AU</option>
      </select>
    </div>
    <div className="mt2">
      <b>Filter by platform: </b>
      <select
        name="platform"
        onChange={e =>
          handleClick(null, null, null, null, e.currentTarget.value)
        }
      >
        <option value="all">All</option>
        <option value="mobile">Mobile</option>
        <option value="desktop">Desktop</option>
      </select>
    </div>
    <div className="mt2">
      <b>Sort by: </b>
      <select name="sort" onChange={e => handleSort(e.currentTarget.value)}>
        <option value="time">Time (oldest first)</option>
        <option value="time_new">Time (newest first)</option>
        <option value="url">Url</option>
      </select>
    </div>
  </div>
);

export default QueueCompanyFilter;
